export default "__VITE_ASSET__BCFR69l4__"